// The test sites (staging.vizbi.org, dev.…): the orange "test site" banner shows there
// (Popup/Warning.vue), and the cookie consent banner doesn't, so it never covers it (2026-10-13)
export const isTestSite = /(^|\.)(staging|dev)\./.test(window.location.host);
